// Helper functions for prompt management

export const extractVariables = (template: string): string[] => {
  const regex = /{{(\w+)}}/g;
  const variables = new Set<string>();
  let match;
  
  while ((match = regex.exec(template)) !== null) {
    variables.add(match[1]);
  }
  
  return Array.from(variables);
};

export const validateTemplate = (template: string): { valid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  // Check for unclosed brackets
  const openCount = (template.match(/{{/g) || []).length;
  const closeCount = (template.match(/}}/g) || []).length;
  
  if (openCount !== closeCount) {
    errors.push('Unmatched variable brackets');
  }
  
  // Check for empty variables
  if (template.includes('{{}}')) {
    errors.push('Empty variable names are not allowed');
  }
  
  // Check for nested variables
  if (template.match(/{{[^}]*{{/)) {
    errors.push('Nested variables are not allowed');
  }
  
  return {
    valid: errors.length === 0,
    errors
  };
};

export const highlightVariables = (template: string): string => {
  return template.replace(
    /{{(\w+)}}/g,
    '<span class="text-blue-600 font-semibold">{{$1}}</span>'
  );
};

export const getTemplateTypeColor = (type: string): string => {
  const colors: Record<string, string> = {
    system: 'bg-purple-100 text-purple-700',
    user: 'bg-green-100 text-green-700',
    analysis: 'bg-blue-100 text-blue-700',
    scoring: 'bg-orange-100 text-orange-700',
  };
  return colors[type] || 'bg-gray-100 text-gray-700';
};